// @core/api/endpoints/authn/revoke_oauth2_consent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/authn';

/**
 * Revoke OAuth2 consent
 * Removes the user's consent for an OAuth2 client, preventing further access. Also revokes all active tokens issued to this client for the user.
 */
export async function RevokeOAuth2Consent(
  client_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/consents/:client_id`;
  requestPath = requestPath.replace(':client_id', encodeURIComponent(client_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
